import { posExternalLocationMappingSchema } from "@redotech/redo-return-core-common/pos-external-location";
import * as z from "zod";

export const updatePosSettings = {
  name: "updatePosSettings" as const,
  input: z.object({
    defaultRestock: z.boolean().optional(),
    sendOnlyCompletionEmail: z.boolean().optional(),
    allowPOSAdjustments: z.boolean().optional(),
    allowPOSManualDiscounts: z.boolean().optional(),
    externalLocationMappings: z
      .array(posExternalLocationMappingSchema)
      .optional(),
  }),
  output: z.object({}),
};
